module.exports = __webpack_public_path__ + "img/32.1bc94694.png";